import { Stepper } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const StepperProcess = ({ steps, activeStep }) => {
  return (
    <Styles.StepperContainer>
      <Stepper steps={steps} activeStep={activeStep} />
    </Styles.StepperContainer>
  )
}

export default StepperProcess
